/*
 * B2B-Pflichtbestätigung (§ 14 BGB)
 * Blockiert jeden Weg zur Kasse aus dem Warenkorb, solange die Checkbox nicht angehakt ist.
 * Läuft in der Capture-Phase und damit vor dem Klick-Handler der Großhandels-App (wds_cart_checkout).
 * Auf Seiten ohne Checkbox (z. B. Warenkorb-Popup) führt „Auschecken“ zum Warenkorb.
 */
(function () {
  if (window.__b2bBestaetigung) return;
  window.__b2bBestaetigung = true;
  var ATTR = 'B2B-Bestätigung';
  var KASSE =
    "button[name='checkout'], input[name='checkout'], [href$='/checkout'], [href$='checkout'], " +
    "form[action$='/checkout'] [type='submit'], .wds_checkout_btn, .additional-checkout-buttons, .additional-checkout-button";
  var speichern = null;

  function checkbox() {
    return document.getElementById('B2bBestaetigungCheckbox');
  }

  function attributSetzen(wert) {
    var attrs = {};
    attrs[ATTR] = wert;
    speichern = fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    })
      .catch(function () {})
      .then(function () {
        speichern = null;
      });
    return speichern;
  }

  function fehler(anzeigen) {
    var box = document.getElementById('B2bBestaetigung');
    var msg = document.getElementById('B2bBestaetigungFehler');
    if (!box || !msg) return;
    msg.hidden = !anzeigen;
    box.classList.toggle('b2b-bestaetigung--fehler', anzeigen);
  }

  function buttonsMarkieren() {
    var cb = checkbox();
    if (!cb) return;
    document.querySelectorAll(KASSE).forEach(function (el) {
      el.classList.toggle('b2b-gesperrt', !cb.checked);
      el.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
    });
  }

  function istKassenWeg(target) {
    return target && target.closest ? target.closest(KASSE) : null;
  }

  function blockieren(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  // Klicks auf alle Kassen-Buttons abfangen (Capture-Phase, vor der Großhandels-App)
  document.addEventListener(
    'click',
    function (event) {
      var el = istKassenWeg(event.target);
      if (!el) return;
      var cb = checkbox();

      if (!cb) {
        // z. B. Warenkorb-Popup: zuerst in den Warenkorb, dort bestätigen
        blockieren(event);
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      if (!cb.checked) {
        blockieren(event);
        fehler(true);
        cb.focus();
        document.getElementById('B2bBestaetigung').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (speichern) {
        // Attribut wird noch gespeichert: kurz warten, dann erneut auslösen
        blockieren(event);
        speichern.then(function () {
          el.click();
        });
      }
    },
    true
  );

  // Enter-Taste / direktes Absenden des Warenkorb-Formulars zur Kasse
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var submitter = event.submitter;
      var zurKasse =
        (submitter && submitter.name === 'checkout') ||
        (form && form.action && /\/checkout$/.test(form.action));
      if (!zurKasse) return;
      var cb = checkbox();
      if (!cb) {
        blockieren(event);
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      if (!cb.checked) {
        blockieren(event);
        fehler(true);
        cb.focus();
      }
    },
    true
  );

  function init() {
    var cb = checkbox();
    if (!cb) return;
    // Bei jedem Besuch des Warenkorbs aktiv neu bestätigen lassen
    cb.checked = false;
    if (cb.dataset.b2bReset === 'true') attributSetzen('');
    cb.addEventListener('change', function () {
      fehler(false);
      buttonsMarkieren();
      attributSetzen(cb.checked ? cb.value : '');
    });
    buttonsMarkieren();
    // Express-Buttons werden nachgeladen, daher später nochmals markieren
    setTimeout(buttonsMarkieren, 1500);
    setTimeout(buttonsMarkieren, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
